module.exports = __webpack_public_path__ + "img/multi2.2dbade5d.png";